export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xIIzIXKMny.08055fc3.woff2";